/**
 * @export {function}
 * @description 正则表达式验证邮箱格式
 * @param {string} email
 * @returns {boolean}
 */
export function checkEmail(email) {
	return new RegExp('^[\\w._-]+@[a-z0-9]+\\.[a-z]{2,4}$').test(email)
}

/**
 * @export {function}
 * @description 正则表达式验证手机号格式
 * @param {string|number} phone
 * @returns {boolean}
 */
export function checkPhone(phone) {
	if (phone !== '') {
		var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
		var isok = reg.test(phone)
		if (isok) {
			return true
		} else {
			return false
		}
	} else {
		return false
	}
}

/**
 * @export {function}
 * @description 正则表达式验证身份证格式
 * @param {string} idCard
 * @returns {boolean}
 */
export function checkIdCard(idCard) {
	if (idCard !== '') {
		var reg = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)?$/i
		var isok = reg.test(idCard)
		if (isok) {
			return true
		} else {
			return false
		}
	} else {
		return false
	}
}

/**
 * @export {function}
 * @description 验证是否含有特殊字符
 * @param {string} t
 * @returns {boolean} true-通过验证,不含有特殊字符, false-不通过验证,含有特殊字符
 */
export function checkSpecialChar(t) {
	var re = /^[\u4e00-\u9fa5a-z]+$/gi // 只能输入汉字和英文字母
	if (re.test(t)) {
		return true
	} else {
		return false
	}
}

export function checkSpecialChar2(t) {
	var re = /[^\w/]/gi // 只能输入数字和英文字母
	if (re.test(t)) {
		return true
	} else {
		return false
	}
}

/**
 * 车牌号验证方法
 * @param vehicleNumber
 * @returns {boolean}
 */
export function checkCarNumber(vehicleNumber) {
	var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
	var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
	if (vehicleNumber.length === 7) {
		return creg.test(vehicleNumber)
	} else if (vehicleNumber.length === 8) {
		return xreg.test(vehicleNumber)
	} else {
		return false
	}
}
